"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLogger = setLogger;
exports.setLoggingEnabled = setLoggingEnabled;
exports.addLoggingListener = addLoggingListener;
exports["default"] = log;

var _pino = _interopRequireDefault(require("pino"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var logger = (0, _pino["default"])({
  base: null,
  formatters: {
    level: function level(label) {
      return {
        level: label
      };
    }
  }
});
var loggingEnabled = true;
var listeners = [];

var writeLogToOutput = function writeLogToOutput(logLevel, args) {
  logger[logLevel](args);
};

var writeLogToOutputIfEnabled = loggingEnabled ? writeLogToOutput : function () {};

function produceLog(logLevel, args) {
  writeLogToOutputIfEnabled(logLevel, args);
  listeners.forEach(function (listener) {
    return listener(Date.now(), JSON.stringify(args));
  });
}

function setLogger(pretty) {
  logger = (0, _pino["default"])(_objectSpread({
    base: null,
    formatters: {
      level: function level(label) {
        return {
          level: label
        };
      }
    }
  }, pretty && {
    prettyPrint: {
      translateTime: 'SYS:yyyy-mm-dd HH:MM:ss',
      messageFormat: 'Anyware Intermedia Engine::\x1b[0m {msg}',
      ignore: 'level'
    }
  }));
}

function setLoggingEnabled(enabled) {
  loggingEnabled = !!enabled;
  writeLogToOutputIfEnabled = enabled ? writeLogToOutput : function () {};
}

function addLoggingListener(listener) {
  listeners.push(listener);
}

function log(args) {
  produceLog('info', args);
}

log.trace = function (args) {
  return produceLog('trace', args);
};

log.debug = function (args) {
  return produceLog('debug', args);
};

log.warn = function (args) {
  return produceLog('warn', args);
};

log.error = function (args) {
  return produceLog('error', args);
};

log.fatal = function (args) {
  return produceLog('fatal', args);
};

log.silent = function (args) {
  return produceLog('silent', args);
};